import type { NtfyConfig } from "../vite-env";

// 정적 설정 — 예전엔 Go 서버가 /config.js 로 window.config 를 만들었다. 이제 웹은 nginx 가 정적으로 주고
// API 는 같은 오리진의 /api/v2 라서 서버가 알려 줄 것이 없다. 코드 곳곳의 "bare config"(import 없는
// config.base_url)도 그대로 돌도록 window.config 에도 넣는다 — 이 모듈은 index.tsx 가 가장 먼저 import 한다.
const config: NtfyConfig = {
  base_url: window.location.origin,
  app_root: "/",
  enable_login: true,
  require_login: true,
  enable_signup: false,
  enable_reservations: false,
  enable_payments: false,
  enable_emails: false,
  enable_email_verify: false,
  enable_calls: false,
  enable_web_push: false,
  web_push_public_key: "",
  billing_contact: "",
  // 웹 경로(SPA 라우트·정적 파일·API)와 겹쳐 토픽으로 쓸 수 없는 이름
  disallowed_topics: ["api", "auth-api", "assets", "static", "file", "app", "account", "settings", "login", "v1", "sw.js"],
  config_hash: "static",
};

window.config = config;

export default config;
